import { render } from "./ItemProduto.vue?vue&type=template&id=7419f77c&scoped=true"
import script from "./ItemProduto.vue?vue&type=script&lang=js"
export * from "./ItemProduto.vue?vue&type=script&lang=js"

import "./ItemProduto.vue?vue&type=style&index=0&id=7419f77c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7419f77c"]])

export default __exports__